import { RoomOutputDTO, TimeEventOutputDTO, TimeEventQueryMeetingPopulate, TimeEventQueryPopulate } from "@kalyzee/kast-web-sdk/http";
import { createAppAsyncThunk } from "../../helpers/redux";
import { sdkClient } from "../../helpers/sdk";

interface GetTimeEventsParams {
  room?: string,
  afterDate: Date,
  beforeDate: Date,
}

export const getTimeEvents = createAppAsyncThunk(
  'room/get_time_events',
  async (params: GetTimeEventsParams): Promise<TimeEventOutputDTO[]> => {
    const response = await sdkClient.getHttpClient().timeEvent.getAll({
      ...params,
      meetingPopulate: [TimeEventQueryMeetingPopulate.ACTOR_IDENTITY],
    });
    return response.data;
  }
);

export const getRoom = createAppAsyncThunk(
  'room/get_one',
  async (id: string): Promise<RoomOutputDTO> => {
    const response = await sdkClient.getHttpClient().room.getById(id);
    return response.data;
  }
);
